module.exports = __webpack_public_path__ + "img/user_win_top3.cb00b853.png";